// Root scope class for everything the widget renders, including the portaled
// Brushaway panel and modals that sit outside any widget-owned DOM ancestor.
// Widget-scoped styling (see AIChatWidgetStyles.scss) keys off this class; the
// stylesheet cannot import this constant, so keep the two in step.
export const WIDGET_SCOPE_CLASS = 'ai-chat-widget';
